export const menu_kebab = () => (
  <path
    d="M6 12h12M3 6h18M9 18h6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
